import { BLUE_900, WHITE } from 'constants/styling/theme'

import Box from '@mui/material/Box'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  count: number
}

export const UnreadCountBadge: FC<Props> = ({ count }) => {
  const { t } = useTranslation(['chat'])

  return (
    <Box
      role="img"
      aria-label={t('chat:conversation_item.unread', { count })}
      sx={{
        minWidth: '1.8rem',
        height: '1.8rem',
        paddingX: '0.4rem',
        borderRadius: '0.9rem',
        backgroundColor: BLUE_900,
        color: WHITE,
        fontSize: '1.1rem',
        fontWeight: 700,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {count}
    </Box>
  )
}
